import * as e from "react";
const t = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ e.createElement("mask", { id: "volume-mute_svg__a", fill: "#fff" }, /* @__PURE__ */ e.createElement("path", { d: "M12.379 3.079A1 1 0 0113 4v16a1 1 0 01-1.7.7L6.58 16H3a1 1 0 01-1-1V9a1 1 0 011-1h3.59l4.7-4.7a1 1 0 011.089-.221zM16.71 8.8l1.79 1.79 1.8-1.8a1 1 0 011.4 1.42L19.92 12l1.8 1.8a1 1 0 01-1.42 1.4l-1.79-1.79-1.8 1.8a1 1 0 01-1.4-1.42L17.08 12h.01l-1.8-1.8a1 1 0 111.42-1.4z" })),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.379 3.079A1 1 0 0113 4v16a1 1 0 01-1.7.7L6.58 16H3a1 1 0 01-1-1V9a1 1 0 011-1h3.59l4.7-4.7a1 1 0 011.089-.221zM16.71 8.8l1.79 1.79 1.8-1.8a1 1 0 011.4 1.42L19.92 12l1.8 1.8a1 1 0 01-1.42 1.4l-1.79-1.79-1.8 1.8a1 1 0 01-1.4-1.42L17.08 12h.01l-1.8-1.8a1 1 0 111.42-1.4z",
      stroke: "#2d6ded",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      mask: "url(#volume-mute_svg__a)"
    }
  )
), l = t;
export {
  l as default
};
